import qs from 'qs';
import client from './client';

const url = '/api/v1/sys/docu-rule';

// 문서번호 규칙 목록 + 현재 접두사
export const getDocuRules = () => client.get(`${url}/list`);

// 저장하지 않고 모양만 확인. sample 은 {PRDTYP}/{ITEM}/{DEPT} 미리보기용 표본 맥락
// (prjTyp/productYn/solutionTyp/deptUuid) - 2026-10-20, bito 기획서 5/07.
export const previewDocuRule = (pattern, docuTyp, sample = {}) =>
  client.get(`${url}/preview?${qs.stringify({ pattern, docuTyp, ...sample })}`);

export const saveDocuRule = (docuTyp, body) => client.put(`${url}/${docuTyp}`, body);

// {PRDTYP}/{ITEM} 짧은 코드 매핑 (blcCd = 'DOCU_PRDTYP' | 'DOCU_ITEM')
export const getCodeMapList = (blcCd) => client.get(`${url}/code-map/${blcCd}`);

export const saveCodeMap = (blcCd, slcCd, code) =>
  client.put(`${url}/code-map`, { blcCd, slcCd, code });

// {DEPT} 부서 코드
export const getDeptCodeList = () => client.get(`${url}/dept-code`);

export const saveDeptCode = (dptUuid, dptCd) =>
  client.put(`${url}/dept-code/${dptUuid}`, { dptCd });
